import { Component, inject, OnInit } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';

import { BmWidgetFiltersComponent } from '../bm-widget-filters/bm-widget-filters.component';
import { ContractStatsComponent } from '../widgets/contract-stats/contract-stats.component';
import { ContractSummaryComponent } from '../widgets/contract-summary/contract-summary.component';
import { TopPolicyReviewComponent } from '../widgets/top-policy-review/top-policy-review.component';
import { TopPerformersComponent } from '../widgets/top-performers/top-performers.component';
import { PolicyAlertsComponent } from '../widgets/policy-alerts/policy-alerts.component';
import { CommonModule } from '@angular/common';
import { PolicyDrilldownComponent } from '../policy-drilldown/policy-drilldown.component';

@Component({
  selector: 'app-home-office-reports',
  templateUrl: './home-office-reports.component.html',
  styleUrls: ['./home-office-reports.component.scss'],
  imports: [
    BmWidgetFiltersComponent,
    ContractStatsComponent,
    ContractSummaryComponent,
    TopPolicyReviewComponent,
    TopPerformersComponent,
    PolicyAlertsComponent,
    CommonModule,
    PolicyDrilldownComponent,
  ],
})
export class HomeOfficeReportsComponent implements OnInit {
  private ss = inject(SessionStorageService);
  rights: string[] = [];
  showPolicyReview = false;
  showPolicyTags = false;
  preexistingWidgetFilters;

  constructor() {}

  ngOnInit() {
    this.rights = this.ss.get('rights');
    this.showPolicyReview = this.rights.includes(
      'PMHomeOfficeTopPolicyReviewOpportunitiesGrid'
    );
    this.showPolicyTags = this.rights.includes(
      'PMHomeOfficeRepPolicyAlertsGrid'
    );
  }

  emitDrilldownFilter(ev) {
    this.preexistingWidgetFilters = { ...ev };
  }
}
